<template>
  <div class="detail">
    <TopBack :title="$t('lang.menu.Kyc')" style="margin-top: 66px;"/>
    <div class="detailContainer">
      <div v-for="(item, index) in kycList" :key="index" :class="item.class" v-html="item.content"></div>
      <div class="bottomLogo">
        <img :src="logo" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import TopBack from '@/components/TopBack/index'
import logo from '@/assets/images/common/logo1.svg'

export default {
  name: 'Privacy',
  data () {
    return {
      logo,
      kycList: this.$t('lang.kycPolicy')
    }
  },
  components: {
    TopBack
  }
}
</script>

<style lang="less" scoped>
  .detail {
    height: 80vh;
    .detailContainer {
      height: 100%;
      overflow: auto;
      margin-top: 22px;
      padding: 0 16px;
      .t0 {
        font-size: 20px;
        line-height: 21px;
        color: #F6D9AA;
        font-weight: bold;
        margin: 20px 0;
      }
      .t1 {
        font-size: 18px;
        line-height: 21px;
        color: #F6D9AA;
        font-weight: bold;
        margin: 20px 0;
      }
      .t2 {
        font-size: 14px;
        line-height: 140%;
        color: #fff;
        margin-bottom: 12px;
      }
      .t3 {
        display: flex;
        font-size: 16px;
        line-height: 19px;
        color: #fff;
        margin-bottom: 10px;
        i {
          margin-left: 10px;
        }
      }
      .bottomLogo {
        text-align: right;
        img {
          width: 40px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Documents/KYCPolicy.vue